export default __webpack_public_path__ + "static/media/h5mgr-hover.e01734df.svg";